import reviewRequestActionTypes from '../actionTypes'

const initialState = {
  data: [],
  totalPages: 1,
  params: {}
}

const reviewRequestsReducer = (state = initialState, action) => {
  switch (action.type) {
    case reviewRequestActionTypes.GET_REVIEW_REQUESTS:
      return {
        ...state,
        data: action.payload.data,
        totalPages: action.payload.totalPages,
        params: action.payload.params
      }
    case reviewRequestActionTypes.STOP_REVIEW_REQUEST:
      return {
        ...state,
        data: state.data.map(item => (
          item.id === action.payload.id 
            ? { ...item, status: 'stopped' } 
            : item
        ))
      }
    case reviewRequestActionTypes.RESEND_REVIEW_REQUEST:
      return {
        ...state,
        data: state.data.map(item => (
          item.id === action.payload.id 
            ? { ...item, resent_at: new Date().toISOString() } 
            : item
        ))
      }
    default:
      return state
  }
}

export default reviewRequestsReducer
